export const products = [
  {
    id: 1,
    slug: "sc-reinforced-wall",
    name: "SC보강토 옹벽블록",
    shortDesc: "고강도 보강토 공법으로 대형 사면 안정화에 최적화된 블록 시스템",
    features: ["최대 높이 15m 이상 시공 가능", "지오그리드 연결 구조", "친환경 식생 적용 가능"],
    image: "https://static.readdy.ai/image/836157e4b911c723a60bdc023d0f92e1/9f4dc754947b65ffd55854b999e4d62e.jpeg",
    color: "#e8621a",
    overview: {
      description: "SC보강토 옹벽블록은 지오그리드 보강재와의 일체화 구조를 통해 대규모 사면 안정화 공사에 최적화된 고성능 블록 시스템입니다. 30여 년의 기술력을 바탕으로 국내외 수천 개의 현장에 적용되었으며, 최대 15m 이상의 수직 높이도 안전하게 시공할 수 있습니다.",
      useCases: ["도로 절토사면 보호", "하천 제방 안정화", "산지 개발 현장 사면 처리", "고속도로 및 철도 부지"],
      certifications: ["KS F 4004 인증", "환경부 친환경 인증", "조달청 우수제품 지정"]
    },
    specs: [
      { label: "규격 (W×H×D)", value: "490 × 200 × 450 mm" },
      { label: "중량", value: "약 55 kg/개" },
      { label: "압축강도", value: "24 MPa 이상" },
      { label: "흡수율", value: "7% 이하" },
      { label: "전면경사", value: "1:0.02 (거의 수직)" },
      { label: "적용 높이", value: "최대 15m 이상" },
      { label: "지오그리드 연결", value: "2단마다 연결 가능" },
      { label: "색상", value: "그레이, 황토, 갈색 (선택)" }
    ],
    drawing: "https://public.readdy.ai/ai/img_res/b67054afd78536ad29d507a4998fa160.jpg"
  },
  {
    id: 2,
    slug: "sc-retaining-wall",
    name: "SC옹벽 축조블록",
    shortDesc: "다양한 경사도에 대응하는 자립형 옹벽 축조 전용 블록",
    features: ["자립식 구조 설계", "경사각 자유 조절", "빠른 시공 속도"],
    image: "https://readdy.ai/api/search-image?query=concrete%20retaining%20wall%20construction%20block%20heavy%20duty%20gray%20precast%20concrete%20masonry%20unit%20smooth%20surface%20professional%20product%20photography%20clean%20white%20background&width=600&height=400&seq=prod002&orientation=landscape",
    color: "#2d6a4f",
    overview: {
      description: "SC옹벽 축조블록은 별도의 지오그리드 없이도 자립이 가능한 구조로 설계되어, 소규모 현장부터 중규모 옹벽 공사까지 폭넓게 활용됩니다. 경사각을 현장 조건에 맞게 자유롭게 조절할 수 있어 시공 유연성이 뛰어나며, 숙련공이 아니어도 빠른 시공이 가능합니다.",
      useCases: ["택지 개발 현장", "주택 단지 경계 옹벽", "농지 정리 공사", "소규모 도로 비탈면"],
      certifications: ["KS F 4004 인증", "조달청 등록 제품"]
    },
    specs: [
      { label: "규격 (W×H×D)", value: "450 × 200 × 380 mm" },
      { label: "중량", value: "약 42 kg/개" },
      { label: "압축강도", value: "21 MPa 이상" },
      { label: "흡수율", value: "8% 이하" },
      { label: "전면경사", value: "1:0.05 ~ 1:0.2 (가변)" },
      { label: "적용 높이", value: "최대 6m" },
      { label: "시공 방식", value: "자립식 (보강재 불필요)" },
      { label: "색상", value: "그레이, 황토 (선택)" }
    ],
    drawing: "https://readdy.ai/api/search-image?query=technical%20blueprint%20engineering%20drawing%20self%20standing%20retaining%20wall%20block%20CAD%20dimensions%20side%20view%20front%20view%20top%20view%20line%20drawing%20white%20background%20professional&width=800&height=560&seq=draw002&orientation=landscape"
  },
  {
    id: 3,
    slug: "sc-vegetation-bank",
    name: "SC식생 호안 축조블록",
    shortDesc: "하천 사면 보호와 녹화를 동시에 실현하는 친환경 호안 블록",
    features: ["식생 공간 내장 구조", "하천 침식 방지", "KS 인증 제품"],
    image: "https://readdy.ai/api/search-image?query=eco%20friendly%20vegetation%20bank%20protection%20concrete%20block%20green%20plant%20growing%20through%20hollow%20concrete%20units%20river%20bank%20protection%20natural%20clean%20background&width=600&height=400&seq=prod003&orientation=landscape",
    color: "#3a7d44",
    overview: {
      description: "SC식생 호안 축조블록은 블록 내부에 식생 공간을 내장하여 하천 사면의 침식을 방지하는 동시에 자연 녹화를 실현합니다. 식물이 자라면서 뿌리가 블록과 지반을 함께 고정해 시간이 지날수록 더욱 안정적인 구조를 형성합니다. 환경부 친환경 공법으로 지정된 제품입니다.",
      useCases: ["하천 호안 보호", "저수지 및 댐 사면", "자연형 하천 복원 사업", "생태공원 수변 시설"],
      certifications: ["KS F 4004 인증", "환경부 자연형 하천 공법 지정", "녹색기술인증"]
    },
    specs: [
      { label: "규격 (W×H×D)", value: "400 × 150 × 350 mm" },
      { label: "중량", value: "약 32 kg/개" },
      { label: "압축강도", value: "21 MPa 이상" },
      { label: "흡수율", value: "8% 이하" },
      { label: "식생 개구율", value: "약 30%" },
      { label: "적용 경사", value: "1:1 ~ 1:2" },
      { label: "시공 방식", value: "맞물림식" },
      { label: "색상", value: "자연 그레이" }
    ],
    drawing: "https://readdy.ai/api/search-image?query=technical%20drawing%20blueprint%20vegetation%20river%20bank%20protection%20hollow%20concrete%20block%20plant%20hole%20dimensions%20CAD%20line%20drawing%20engineering%20document%20white%20background&width=800&height=560&seq=draw003&orientation=landscape"
  },
  {
    id: 4,
    slug: "seko-retaining-wall",
    name: "세코 옹벽 블록",
    shortDesc: "경제성과 시공성을 겸비한 세코 전용 옹벽 블록 시스템",
    features: ["비용 효율 최적화", "다양한 색상 선택", "우수한 내구성"],
    image: "https://readdy.ai/api/search-image?query=SEKO%20precast%20concrete%20wall%20block%20modular%20retaining%20wall%20system%20gray%20textured%20surface%20professional%20industrial%20product%20clean%20studio%20background%20sharp%20details&width=600&height=400&seq=prod004&orientation=landscape",
    color: "#7a5c3a",
    overview: {
      description: "세코 옹벽 블록은 경제적인 공사비와 탁월한 시공성을 동시에 충족하는 범용 옹벽 블록입니다. 다양한 색상 옵션을 제공하여 조경 친화적인 시각 환경을 만들 수 있으며, 높은 내구성으로 장기간 유지관리 비용을 절감할 수 있습니다.",
      useCases: ["일반 주택 및 건축물 부지", "공원 및 녹지 조성", "소단 처리 현장", "민간 건설 현장"],
      certifications: ["KS F 4004 인증", "조달청 등록 제품"]
    },
    specs: [
      { label: "규격 (W×H×D)", value: "500 × 180 × 400 mm" },
      { label: "중량", value: "약 48 kg/개" },
      { label: "압축강도", value: "18 MPa 이상" },
      { label: "흡수율", value: "9% 이하" },
      { label: "전면경사", value: "1:0.05" },
      { label: "적용 높이", value: "최대 4m" },
      { label: "시공 방식", value: "자립식" },
      { label: "색상", value: "그레이, 황토, 적갈색, 갈색 (선택)" }
    ],
    drawing: "https://readdy.ai/api/search-image?query=SEKO%20precast%20wall%20block%20engineering%20blueprint%20technical%20drawing%20dimension%20annotations%20side%20front%20top%20view%20CAD%20professional%20line%20drawing%20white%20background&width=800&height=560&seq=draw004&orientation=landscape"
  },
  {
    id: 5,
    slug: "ready-rock",
    name: "레디락 옹벽 블록",
    shortDesc: "자연석 외관을 구현한 고품격 조경용 옹벽 블록",
    features: ["자연석 패턴 표면", "조경과 토목의 조화", "높은 미관 품질"],
    image: "https://readdy.ai/api/search-image?query=ReadyRock%20natural%20stone%20look%20concrete%20landscape%20retaining%20wall%20block%20decorative%20textured%20surface%20mimicking%20natural%20rock%20clean%20white%20background%20professional%20photography&width=600&height=400&seq=prod005&orientation=landscape",
    color: "#5a4a3a",
    overview: {
      description: "레디락 옹벽 블록은 자연석의 질감과 외관을 콘크리트로 정밀하게 재현한 고품격 조경용 옹벽 블록입니다. 고급 주택단지, 리조트, 공원 등 미관이 중요한 현장에서 탁월한 경관 효과를 발휘합니다. 내구성은 일반 옹벽 블록과 동일하게 유지하면서 시각적 완성도를 높인 제품입니다.",
      useCases: ["고급 주택 단지 외벽", "리조트 및 펜션 조경", "공원 산책로 및 화단", "상업시설 외부 조경"],
      certifications: ["KS F 4004 인증", "품질경영시스템 ISO 9001"]
    },
    specs: [
      { label: "규격 (W×H×D)", value: "450 × 200 × 380 mm" },
      { label: "중량", value: "약 45 kg/개" },
      { label: "압축강도", value: "24 MPa 이상" },
      { label: "흡수율", value: "7% 이하" },
      { label: "표면 처리", value: "자연석 패턴 (몰드 성형)" },
      { label: "적용 높이", value: "최대 5m" },
      { label: "시공 방식", value: "자립식" },
      { label: "색상", value: "차콜, 샌드스톤, 브라운 (선택)" }
    ],
    drawing: "https://readdy.ai/api/search-image?query=ReadyRock%20decorative%20natural%20stone%20retaining%20wall%20block%20technical%20engineering%20blueprint%20CAD%20drawing%20dimensions%20detail%20side%20front%20view%20white%20background%20professional&width=800&height=560&seq=draw005&orientation=landscape"
  }
];

export const companyStats = [
  { value: "30+", label: "년 기술력", desc: "1990년대부터 이어온 축적된 노하우" },
  { value: "3,000+", label: "시공 실적", desc: "전국 공공 및 민간 현장 납품 실적" },
  { value: "5종", label: "전문 제품군", desc: "다양한 현장 조건 맞춤 제품 라인업" }
];
